<template>
  <div>
    <datepicker
      input-class="form-control form-control-sm mb-2"
      :id="name"
      :name="name"
      :minimumView="'day'"
      :maximumView="'year'"
      :initialView="'day'"
      format="dd MMMM yyyy"
      :required="required"
      v-model="post"
      @input="send"
    ></datepicker>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  props: ["name", "validation", "content", "table_module"],
  data() {
    return {
      post: this.content,
      phrases: {
        ok: "Pilih",
        cancel: "Batal",
      },
    };
  },
  components: {
    Datepicker,
  },
  computed: {
    required() {
      if (this.validation == "required") {
        return true;
      }

      return false;
    },
    disabledDates(){
      var res = {};

      if (this.table_module == 'day_off') {
        res = {
          to: new Date()
        }
      }

      return res
    }
  },
  methods: {
    send() {
      if (this.post != "") {
        var arm = this.$moment(this.post).format("YYYY-MM-DD");
      }

      this.$emit("post", {
        name: this.name,
        value: arm,
      });
    },
  },
};
</script>